module.exports = __webpack_public_path__ + "fonts/Gilroy-ExtraBold.aa33f80c.woff";